export default __webpack_public_path__ + "static/media/valores.4b1adc52.png";